import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"display":"inline-block"} }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Opmerking(en)", -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Bestand(en)", -1)
const _hoisted_6 = { key: 2 }

import { computed, onMounted, ref } from 'vue'
import { surveyStore } from '@/stores/survey'
import TextEditor from '@/components/TextEditor.vue'
import Uploader from '@/components/Uploader.vue'
import SurveyAnswerIssues from '@/components/survey/SurveyAnswerIssues.vue'
import axios from 'axios'
import Filelist from '@/components/Filelist.vue'
import { notification } from 'ant-design-vue'
import { CameraFilled, WarningFilled } from '@ant-design/icons-vue'
import ExternalInspectionAnswerIssues from '@/components/survey/ExternalInspectionAnswerIssues.vue'
import InternalInspectionAnswerIssues from '@/components/survey/InternalInspectionAnswerIssues.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyQuestionCard',
  props: {
    question: null,
    chapterIndex: null,
    questionIndex: null
  },
  setup(__props: any) {

const props = __props as { question:{ id:number, name:string, answer: { id:number, answer:string|null, note:string|null, media:{ id:number, url:string }[], issues:{ id:number, title:string, description:string, status:number }[] } }, chapterIndex:number, questionIndex:number };



const screenWidth = computed(() => window.innerWidth)
const answer = ref<{ id?:number, answer:string|null, note:string|null, media:{ id:number, url:string }[], issues:{ id:number, title:string, description:string, status:number }[] }>({ answer: null, note: null, media: [], issues: [] })

onMounted(() => {
  answer.value.id = props.question.answer.id
  answer.value.answer = props.question.answer.answer
  answer.value.note = props.question.answer.note
  answer.value.media = props.question.answer.media
  answer.value.issues = props.question.answer.issues
})

function answerNoteChanged (val:string) : void {
  answer.value.note = val
  surveyStore().updateAnswer(props.question.answer.id, answer.value)
}

function addAnswerMedia (file:File) : void {
  const formData = new FormData()
  formData.append('files', file)

  axios.post(process.env.VUE_APP_API_URL + '/surveys/answers/' + props.question.answer.id + '/media/add', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    answer.value.media.push(r.data.data)
  })
}

function updateAnswerMedia (data:{ file:File, mediaId:number }) : void {
  const formData = new FormData()
  formData.append('files', data.file)
  formData.append('mediaId', data.mediaId.toString())

  axios.post(process.env.VUE_APP_API_URL + '/surveys/answers/' + props.question.answer.id + '/media/update', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => {
    answer.value.media.forEach((m:{ id:number }, index) => {
      if (m.id === data.mediaId) {
        answer.value.media[index] = r.data.data
        notification.success({
          message: 'Afbeelding bijgewerkt.',
          description: 'De afbeelding is succesvol bijgewerkt.',
          duration: 5
        })
      }
    })
  })
}

function deleteFile (file:{ id:number }) : void {
  axios.post(process.env.VUE_APP_API_URL + '/surveys/answers/' + props.question.answer.id + '/media/delete', { mediaId: file.id }).then(() => {
    answer.value.media.forEach((m:{ id:number }, index) => {
      if (m.id === file.id) {
        answer.value.media.splice(index, 1)
        notification.success({
          message: 'Bestand verwijderd.',
          description: 'Het bestand is succesvol verwijderd.',
          duration: 5
        })
      }
    })
  })
}

function issueAdded (issue:{ id:number, title:string, description:string, status:number }) : void {
  answer.value.issues.push(issue)
}

function issueUpdated (issue:{ id:number, title:string, description:string, status:number }) : void {
  answer.value.issues.forEach((i:{ id:number, title:string, description:string, status:number }, index) => {
    if (i.id === issue.id) {
      answer.value.issues[index] = issue
    }
  })
}

function issueDeleted (id:number) : void {
  answer.value.issues.forEach((i:{ id:number, title:string, description:string, status:number }, index) => {
    if (i.id === id) {
      answer.value.issues.splice(index, 1)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_1, _toDisplayString(__props.question.number) + ". " + _toDisplayString(__props.question.name), 1),
            (__props.question.required)
              ? (_openBlock(), _createBlock(_component_a_tag, {
                  key: 0,
                  color: "#f38929",
                  style: _normalizeStyle({ float: _unref(screenWidth) < 768 ? 'left' : 'right' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Verplicht")
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse, { bordered: false }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  header: "Controlepunten",
                  style: {"border-bottom":"5px solid white"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: __props.question.description
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: 6}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_group, {
                      value: answer.value.answer,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((answer.value.answer) = $event)),
                      "button-style": "solid",
                      disabled: _unref(surveyStore)().surveyClosed || !_unref(surveyStore)().isSurveyOwner,
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(surveyStore)().updateAnswer(__props.question.answer.id, answer.value)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_button, { value: "yes" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Goed")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio_button, { value: "no" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Fout")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio_button, { value: "nvt" }, {
                          default: _withCtx(() => [
                            _createTextVNode("N.V.T.")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: 18}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse, { bordered: false }, {
              default: _withCtx(() => [
                (['yes', 'no'].includes(answer.value.answer))
                  ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                      key: 0,
                      header: "Opmerkingen en foto's",
                      style: {"border-bottom":"5px solid white"}
                    }, {
                      extra: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "#666" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CameraFilled)),
                            _createTextVNode(" " + _toDisplayString(answer.value.media.length), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _hoisted_3,
                                (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
                                  ? (_openBlock(), _createBlock(TextEditor, {
                                      key: 0,
                                      content: answer.value.note,
                                      returnOn: "blur",
                                      onContentChange: _cache[2] || (_cache[2] = ($event: any) => (answerNoteChanged($event)))
                                    }, null, 8, ["content"]))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      innerHTML: answer.value.note || '-'
                                    }, null, 8, _hoisted_4))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _hoisted_5,
                                (!_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner)
                                  ? (_openBlock(), _createBlock(Uploader, {
                                      key: 0,
                                      "current-count": answer.value.media.length,
                                      "upload-button": "",
                                      onNewFileUploaded: addAnswerMedia
                                    }, null, 8, ["current-count"]))
                                  : _createCommentVNode("", true),
                                (answer.value.media.length)
                                  ? (_openBlock(), _createBlock(Filelist, {
                                      key: 1,
                                      media: answer.value.media,
                                      onImageEdited: _cache[3] || (_cache[3] = ($event: any) => (updateAnswerMedia($event))),
                                      onDeleteFile: deleteFile,
                                      "can-edit": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner,
                                      "can-comment": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner,
                                      "can-delete": !_unref(surveyStore)().surveyClosed && _unref(surveyStore)().isSurveyOwner
                                    }, null, 8, ["media", "can-edit", "can-comment", "can-delete"]))
                                  : (!_unref(surveyStore)().isSurveyOwner)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "-"))
                                    : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (answer.value.answer === 'no')
                  ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                      key: 1,
                      header: "Gebrek(en)",
                      style: {"border-bottom-color":"white"}
                    }, {
                      extra: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "#666" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(WarningFilled)),
                            _createTextVNode(" " + _toDisplayString(__props.question.answer.issues.length), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_unref(surveyStore)().isInternalInspection)
                          ? (_openBlock(), _createBlock(InternalInspectionAnswerIssues, {
                              key: 0,
                              answer: answer.value,
                              chapterIndex: props.chapterIndex,
                              questionIndex: props.questionIndex,
                              onIssueAdded: _cache[4] || (_cache[4] = ($event: any) => (issueAdded($event))),
                              onIssueUpdated: _cache[5] || (_cache[5] = ($event: any) => (issueUpdated($event))),
                              onIssueDeleted: _cache[6] || (_cache[6] = ($event: any) => (issueDeleted($event)))
                            }, null, 8, ["answer", "chapterIndex", "questionIndex"]))
                          : _createCommentVNode("", true),
                        (_unref(surveyStore)().isExternalInspection)
                          ? (_openBlock(), _createBlock(ExternalInspectionAnswerIssues, {
                              key: 1,
                              answer: answer.value,
                              chapterIndex: props.chapterIndex,
                              questionIndex: props.questionIndex,
                              onIssueAdded: _cache[7] || (_cache[7] = ($event: any) => (issueAdded($event))),
                              onIssueUpdated: _cache[8] || (_cache[8] = ($event: any) => (issueUpdated($event))),
                              onIssueDeleted: _cache[9] || (_cache[9] = ($event: any) => (issueDeleted($event)))
                            }, null, 8, ["answer", "chapterIndex", "questionIndex"]))
                          : _createCommentVNode("", true),
                        (!_unref(surveyStore)().isSpecialInspection)
                          ? (_openBlock(), _createBlock(SurveyAnswerIssues, {
                              key: 2,
                              answer: answer.value,
                              onIssueAdded: _cache[10] || (_cache[10] = ($event: any) => (issueAdded($event))),
                              onIssueUpdated: _cache[11] || (_cache[11] = ($event: any) => (issueUpdated($event))),
                              onIssueDeleted: _cache[12] || (_cache[12] = ($event: any) => (issueDeleted($event)))
                            }, null, 8, ["answer"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_divider)
  ], 64))
}
}

})